var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.9612 13.2635C26.3048 14.0313 26.3048 15.9687 24.9611 16.7365L2.99228 29.2901C1.65896 30.052 0 29.0893 0 27.5537V2.44638C0 0.91073 1.65896 -0.0520041 2.99228 0.709889L24.9612 13.2635Z","fill":"white"}));
}

Play.defaultProps = {"width":"26","height":"30","viewBox":"0 0 26 30","fill":"none"};

module.exports = Play;

Play.default = Play;
